// Logică pură de concedii pentru EmployeeDetails.vue: clasificarea tipului „anual de
// odihnă", detecția suprapunerilor aprobate și setul de zile blocate. Funcțiile primesc
// datele ca parametri (fără refs), deci componenta păstrează aceleași semnături și doar
// delegă nucleul aici.
import { toDateObject, formatAsIsoDate } from "./holidayFormatting.mjs";

export const ANNUAL_LEAVE_CODES = new Set(["annual_leave"]);
export const ANNUAL_LEAVE_NAMES = new Set([
  "Concediu anual de odihnă",
  "Concediu anual de odihnă - plătit",
  "Concediu anual de odihnă • plătit",
]);

export const isAnnualLeaveType = (type) => {
  if (!type) return false;
  if (type.code && ANNUAL_LEAVE_CODES.has(type.code)) return true;
  if (type.name_ro && ANNUAL_LEAVE_NAMES.has(type.name_ro)) return true;
  return false;
};

// Există o cerere de concediu anual APROBATĂ care se suprapune cu intervalul [start, end]?
// `holidayTypeMap` este un Map<number, type>. Guard-ul de tip (currentTypeReducesBalance)
// rămâne în componentă; aici tratăm doar suprapunerea propriu-zisă.
export const hasApprovedAnnualLeaveOverlap = ({
  startValue,
  endValue,
  excludeId = null,
  holidayRequests = [],
  holidayTypeMap,
}) => {
  if (!startValue || !endValue || !holidayTypeMap) return false;
  const startDate = new Date(startValue);
  const endDate = new Date(endValue);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return false;
  if (endDate < startDate) return false;

  return holidayRequests.some((req) => {
    if (excludeId && Number(req.id) === Number(excludeId)) return false;
    if (req.status !== "approved") return false;
    if (!isAnnualLeaveType(holidayTypeMap.get(Number(req.holiday_type_id)))) return false;
    const reqStart = new Date(req.start_date);
    const reqEnd = new Date(req.end_date);
    if (Number.isNaN(reqStart.getTime()) || Number.isNaN(reqEnd.getTime())) return false;
    return startDate <= reqEnd && endDate >= reqStart;
  });
};

// Setul de zile (ISO) deja ocupate de concedii anuale aprobate (exceptând cererea editată),
// folosit pentru a bloca selecția în calendar.
export const buildBlockedAnnualLeaveDays = ({
  holidayRequests = [],
  holidayTypeMap,
  excludeId = null,
}) => {
  const set = new Set();
  if (!holidayTypeMap) return set;
  const editingId = excludeId ? Number(excludeId) : null;
  holidayRequests.forEach((req) => {
    if (req.status !== "approved") return;
    if (editingId && Number(req.id) === editingId) return;
    if (!isAnnualLeaveType(holidayTypeMap.get(Number(req.holiday_type_id)))) return;
    const start = toDateObject(req.start_date);
    const end = toDateObject(req.end_date);
    if (!start || !end) return;
    const cursor = new Date(start);
    while (cursor <= end) {
      const iso = formatAsIsoDate(cursor);
      if (iso) set.add(iso);
      cursor.setDate(cursor.getDate() + 1);
    }
  });
  return set;
};
